export const adicionar = (item) => {
  return {
    type: 'ADICIONAR',
    payload: item
  };
};

export const remover = (index) => {
  return {
    type: 'REMOVER',
    payload: index
  };
};

export const fechar = (index) => {
  const parsedIndex = Number(index);

  return {
    type: 'FECHAR',
    payload: parsedIndex
  };
};

export const editarConta = (index) => {
  return {
    type: 'EDITARCONTA',
    payload: index
  };
};

export const editarProdutos = (index) => {
  return {
    type: 'EDITARPRODUTOS',
    payload: index
  };
};

export const editarCamposConta = (index) => {
  return {
    type: 'EDITARCAMPOSCONTA',
    payload: index
  };
};

export const editarCamposPedidoDeGas = (index) => {
  return {
    type: 'EDITARCAMPOSPEDIDODEGAS',
    payload: index
  };
};
